import React, { ReactElement } from 'react';
import { Link } from 'react-router-dom';
import { Style } from '../interfaces';

import styles from '../assets/styles/navigation.module.css';

const pages = {
	home: {
		_aliases: ['']
	},
	projects: {},
	portfolio: {},
	articles: {},
	music: {},
	about: {}
} as {[key: string]: Style};

export default class Navigation extends React.Component {

	render(): ReactElement {
		return (
			<div className={styles.navigation}>
				{Object.entries(pages).map(([k, v]) => {
					let style = Object.assign({}, v);
					if ((style._aliases || []).concat([k]).some((p) => {
						if (p) {
							if (window.location.pathname.startsWith(process.env.PUBLIC_URL + '/' + p)) return true;
						} else {
							if (window.location.pathname === process.env.PUBLIC_URL + '/' + p) return true;
						}
						return false;
					}))	style.opacity = 1.0;
					if (style._aliases) delete style._aliases;
					return (
						<Link key={'navigation.' + k} to={'/' + (k === 'home' ? '' : k)} style={style} onClick={() => this.forceUpdate()}>
							<h3>{k}</h3>
						</Link>
					)
				})}
			</div>
		);
	}
}